/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.08.2016.
 */

/**
 *
 * @type {{asset_id: number}}
 */
export const EMIT_COLLECTION_NOTIFICATION_UPDATE = 'emit-' + lh.common.events.EVENT_COLLECTION_NOTIFICATION_UPDATE;
export const EMIT_COLLECTION_RECORDS_UPDATE = 'emit-' + lh.common.events.EVENT_COLLECTION_RECORDS_UPDATE;
export const EMIT_COLLECTION_FAVORITES_UPDATE = 'emit-' + lh.common.events.EVENT_COLLECTION_FAVORITES_UPDATE;
export const EMIT_COLLECTION_PURCHASES_UPDATE = 'emit-' + lh.common.events.EVENT_COLLECTION_PURCHASES_UPDATE;
export const EMIT_COLLECTION_SUBSCRIPTIONS_UPDATE = 'emit-' + lh.common.events.EVENT_COLLECTION_SUBSCRIPTIONS_UPDATE;
export const EMIT_VLIVE_SHOW_OVERLAY = 'emit-' + lh.common.events.EVENT_VLIVE_SHOW_OVERLAY;



// WEBPACK FOOTER //
// ./src/actions/emit/actions-emit.js